import { ListCompanyPixelsRO, SearchEmailCampaignsRO } from "@intentsify/dto";
import { apiService, Endpoints } from "api";
import { FetchDataParamsWithToken } from "types";
import { CompanyPixel } from "@intentsify/types";

const listCompanyPixels = async (
  companyId: number,
  params: FetchDataParamsWithToken<keyof CompanyPixel>,
): Promise<ListCompanyPixelsRO> => {
  const { data } = await apiService.get<ListCompanyPixelsRO>(
    Endpoints.Companies.Get.ListPixels(companyId),
    { params },
  );

  return data;
};

const searchEmailCampaigns = async (params: {
  search?: string;
  pageToken?: string;
}): Promise<SearchEmailCampaignsRO> => {
  const { data } = await apiService.get<SearchEmailCampaignsRO>(
    Endpoints.EmailCampaigns.Get.List,
    { params },
  );

  return data;
};

export { listCompanyPixels, searchEmailCampaigns };
